import { gql } from "@apollo/client";

export const OWNED_PHONE_NUMBER_POOL_FIELDS = gql`
  fragment OwnedPhoneNumberPoolFields on OwnedPhoneNumberPool {
    id
    type
    name
    createdAt
    archivedAt
    tenantId
  }
`;

export const LIST_OWNED_PHONE_NUMBER_POOLS = gql`
  ${OWNED_PHONE_NUMBER_POOL_FIELDS}
  query ListOwnedPhoneNumberPools($input: ListOwnedPhoneNumberPoolsInput!) {
    listOwnedPhoneNumberPools(input: $input) {
      ...OwnedPhoneNumberPoolFields
    }
  }
`;

export const CREATE_OWNED_PHONE_NUMBER_POOL = gql`
  ${OWNED_PHONE_NUMBER_POOL_FIELDS}
  mutation CreateOwnedPhoneNumberPool(
    $input: CreateOwnedPhoneNumberPoolInput!
  ) {
    createOwnedPhoneNumberPool(input: $input) {
      ...OwnedPhoneNumberPoolFields
    }
  }
`;

export const OWNED_PHONE_NUMBER_POOL_DETAIL_FIELDS = gql`
  ${OWNED_PHONE_NUMBER_POOL_FIELDS}

  fragment OwnedPhoneNumberPoolDetailFields on OwnedPhoneNumberPool {
    ...OwnedPhoneNumberPoolFields
    areaCodeSummary {
      areaCode
      count
    }
    purchases {
      id
      createdByUser {
        id
        fullName
      }
      createdAt
      areaCodesRequested
      qtyRequested
      qtyPurchased
      trackedJob {
        id
        status
        errorMessage
        result {
          notes
          outcome
        }
      }
    }
  }
`;

export const GET_OWNED_PHONE_NUMBER_POOL_DETAILS = gql`
  ${OWNED_PHONE_NUMBER_POOL_DETAIL_FIELDS}
  query GetOwnedPhoneNumberPoolDetails($input: GetOwnedPhoneNumberPoolInput!) {
    getOwnedPhoneNumberPool(input: $input) {
      ...OwnedPhoneNumberPoolDetailFields
    }
  }
`;

export const CREATE_OWNED_PHONE_NUMBER_POOL_PURCHASE = gql`
  ${OWNED_PHONE_NUMBER_POOL_DETAIL_FIELDS}
  mutation CreateOwnedPhoneNumberPoolPurchase(
    $input: CreateOwnedPhoneNumberPoolPurchaseInput!
  ) {
    createOwnedPhoneNumberPoolPurchase(input: $input) {
      ...OwnedPhoneNumberPoolDetailFields
    }
  }
`;

export const ARCHIVE_OWNED_PHONE_NUMBER_POOL = gql`
  ${OWNED_PHONE_NUMBER_POOL_FIELDS}
  mutation ArchiveOwnedPhoneNumberPool(
    $input: ArchiveOwnedPhoneNumberPoolInput!
  ) {
    archiveOwnedPhoneNumberPool(input: $input) {
      ...OwnedPhoneNumberPoolFields
    }
  }
`;

export const UNARCHIVE_OWNED_PHONE_NUMBER_POOL = gql`
  ${OWNED_PHONE_NUMBER_POOL_FIELDS}
  mutation UnarchiveOwnedPhoneNumberPool(
    $input: UnarchiveOwnedPhoneNumberPoolInput!
  ) {
    unarchiveOwnedPhoneNumberPool(input: $input) {
      ...OwnedPhoneNumberPoolFields
    }
  }
`;
